// src/data/talents.js
export const TALENT_POOL = [
  { 
    id: "rich", 
    name: "💰 富二代", 
    desc: "开局存款 +50000，但老妈每周催婚心情变差", 
    cost: 5,
    initialBonus: { money: 50000 }
  },
  { 
    id: "evil", 
    name: "😈 天生坏种", 
    desc: "舆论越高潮，心情越爽！乐子人", 
    cost: 10 
  },
  { 
    id: "shifung", 
    name: "🛡️ 甩锅大师", 
    desc: "所有导致“稳定性”扣减的事件，效果减半", 
    cost: 8 
  }
];